import React from "react";
import { createBrowserRouter, createHashRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Home from "./components/Home/Home";
import NotFound from "./components/Notfound/NotFound";
import Products from "./components/Products/Products";
import Cart from "./components/Cart/Cart";
import Register from "./components/Register/Register";
import Login from "./components/Login/Login";
import UserContextProvider from "./context/User/Context";
import ForgetPassword from "./components/ForgetPassword/ForgetPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Payment from "./components/Payment/Payment";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import HowToOrder from "./components/HowToOrder/HowToOrder";
import AddVehicle from "./components/AddVehicle/AddVehicle";
import ProductDetails from "./components/ProductDetails/ProductDetails";
import CartContextProvider from "./context/Car/CarContext";
import { Toaster } from "react-hot-toast";
import ProductContextProvider from "./context/Product/ProductContext";
import Dashboard from "./components/Dashboard/Dashboard";
import LayoutDashboard from "./components/LayoutDashboard/LayoutDashboard";
import Users from "./components/Dashboard/Users/Users";
import Cars from "./components/Dashboard/Cars/Cars";
import Messages from "./components/Dashboard/Messages/Messages";
import ProductsDash from "./components/Dashboard/Products/Products";
import Category from "./components/Dashboard/Category/Category";
import PackageDashborad from "./components/Dashboard/Package/Package";
import Package from "./components/Package/Package";
import OrderAndPayment from "./components/Dashboard/OrderAndPayment/OrderAndPayment";
import PackageContextProvider from "./context/PackageContext/PackageContext";
import PackageDetails from "./components/Package/PackageDetails";
import StoreContextProvider from "./context/StoreContext/StoreContext";
import ProtectedAdmin from "./components/ProtectedRoute/ProtectedAdmin";

let routers = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "products", element: <Products /> },
      { path: "cart", element: <Cart /> },
      { path: "productDetails/:id", element: <ProductDetails /> },
      { path: "packageDetails/:id", element: <PackageDetails /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "howtoorder", element: <HowToOrder /> },
      { path: "package", element: <Package /> },
      {
        path: "payment",
        element: (
          <ProtectedRoute>
            <Payment />
          </ProtectedRoute>
        ),
      },
      { path: "register", element: <Register /> },
      { path: "login", element: <Login /> },
      { path: "forgetPassword", element: <ForgetPassword /> },
      {
        path: "addVehicle",
        element: (
          <ProtectedRoute>
            <AddVehicle />
          </ProtectedRoute>
        ),
      },
      { path: "resetPassword", element: <ResetPassword /> },
    ],
  },
  { path: "*", element: <NotFound /> },
  {
    path: "dashboard",
    element: <ProtectedAdmin><LayoutDashboard /></ProtectedAdmin>,
    children: [
      { path: "", element: <ProtectedAdmin><Dashboard /></ProtectedAdmin> },
      { path: "users", element: <ProtectedAdmin><Users /></ProtectedAdmin> },
      { path: "cars", element: <ProtectedAdmin><Cars /></ProtectedAdmin> },
      { path: "messages", element: <ProtectedAdmin><Messages /></ProtectedAdmin> },
      { path: "products", element: <ProtectedAdmin><ProductsDash /></ProtectedAdmin> },
      { path: "category", element: <ProtectedAdmin><Category /></ProtectedAdmin> },
      { path: "package", element: <ProtectedAdmin><PackageDashborad /></ProtectedAdmin> },
      { path: "order", element: <ProtectedAdmin><OrderAndPayment /></ProtectedAdmin> },
    ],
  },
]);

export default function App() {
  return (
    // <StoreContextProvider>
          <PackageContextProvider>
      <ProductContextProvider>
        <CartContextProvider>
          <UserContextProvider>
            <RouterProvider router={routers}></RouterProvider>
          </UserContextProvider>
          <Toaster />
        </CartContextProvider>
      </ProductContextProvider>
    </PackageContextProvider>
    // </StoreContextProvider>

  );
}
